export const aemhContentTransformation = ({ fields }: ContentAem): Banner => {
  const {
    bannerLayout,
    ctaUrl,
    imageAlt,
    assetImageLarge,
    assetImageMedium,
    assetImageSmall,
    alignment = 'center',
    fullWidth,
    copy,
    ctaLabel,
    headline,
    headlineHierarchy,
    icon,
    imgAlignment,
    ctaAlt,
    textAlignment = 'left',
    theme,
  } = fields;

  return {
    bannerLayout,
    copy,
    ctaLabel,
    headline,
    headlineHierarchy,
    icon,
    imgAlignment,
    ctaUrl,
    ctaAlt,
    imageAlt,
    imageSrcLarge:
      bannerLayout !== 'textOnly'
        ? assetImageLarge?.path || assetImageMedium?.path || assetImageSmall?.path || ''
        : '',
    imageSrcMedium:
      bannerLayout !== 'textOnly'
        ? assetImageMedium?.path || assetImageLarge?.path || assetImageSmall?.path || ''
        : '',
    imageSrcSmall:
      bannerLayout !== 'textOnly'
        ? assetImageSmall?.path || assetImageMedium?.path || assetImageLarge?.path || ''
        : '',
    alignment,
    fullWidth,
    textAlignment,
    theme,
  };
};
